export class Smgmanufacturer {
    id: number;
    vendorRegistrationId: string;
    applicationNumber: string;
    applicationDate: Date;
    smgNo: string;
    smgId: string;
    desciprtion: string;
    addressof_Manufacturing_Unit: string;
    city: string;
    state: string;
    country: string;
    pinCode: string;
    financialYear1: string;
    purschaseOrderNo1: string;
    poDate1: Date;
    poValue1: string;
    client1: string;
    briefDescriptionofMaterial: string;
    evaluatorsFigure1: string;
    comments1: string;
    financialYear2: string;
    purschaseOrderNo2: string;
    poDate2: Date;
    poValue2: string;
    client2: string;
    evaluatorsFigure2: string;
    comments2: string;
    financialYear3: string;
    purschaseOrderNo3: string;
    poDate3: Date;
    poValue3: string;
    client3: string;
    evaluatorsFigure3: string;
    comments3: string;
    avgValue: string;
    totalValue: string;
    commentsTotalValue: string;
    unitofMeasure: string;

    // productionCapacityPerDay :string;
    // productionValuePerDay :string;
    // supplyCapacityPerDay :string;
    // supplyValuePerDay :string;
    // productionCapacityPerMonth1 :string;
    // productionValuePerMonth1 :string;
    // supplyCapacityPerMonth1 :string;
    // supplyValuePerMonth1 :string;
    // productionCapacityPerMonth2 :string;
    // productionValuePerMonth2 :string;
    // supplyCapacityPerMonth2 :string;
    // supplyValuePerMonth2 :string;

    production_Capacity_Per_Day: string;
    production_Value_Per_Day: string;
    supply_Capacity_Per_Day: string;
    supply_Value_Per_Day: string;
    production_Capacity_Per_Month1: string;
    production_Value_Per_Month1: string;
    supply_Capacity_Per_Month1: string;
    supply_Value_Per_Month1: string;
    production_Capacity_Per_Month2: string;
    production_Value_Per_Month2: string;
    supply_Capacity_Per_Month2: string;
    supply_Value_Per_Month2: string;


    modified: Date;
    created: Date;
    createdBy: string;
    modifiedBy: string;

    //another module
/*
    int: number;
    vendorRegistrationId: string;
    applicationNumber: string;
    applicationDate: Date;
    smgNo: string;
    smgId: string;
    desciprtion: string;
    addressof_Manufacturing_Unit: string;
    city: string;
    state: string;
    country: string;
    pinCode: string;
    financialYear1: string;
    purschaseOrderNo1: string;
    poDate1: Date;
    poValue1: string;
    client1: string;
    briefDescriptionofMaterial: string;
    evaluatorsFigure1: string;
    comments1: string;
    financialYear2: string;
    purschaseOrderNo2: string;
    poDate2: Date;
    poValue2: string;
    client2: string;
    evaluatorsFigure2: string;
    comments2: string;
    financialYear3: string;
    purschaseOrderNo3: string;
    poDate3: Date;
    poValue3: string;
    client3: string;
    evaluatorsFigure3: string;
    comments3: string;
    avgValue: string;
    totalValue: string;
    commentsTotalValue: string;
    unitofMeasure: string;

    production_Capacity_Per_Day: string;
    production_Value_Per_Day: string;
    supply_Capacity_Per_Day: string;
    supply_Value_Per_Day: string;
    production_Capacity_Per_Month1: string;
    production_Value_Per_Month1: string;
    supply_Capacity_Per_Month1: string;
    supply_Value_Per_Month1: string;
    production_Capacity_Per_Month2: string;
    production_Value_Per_Month2: string;
    supply_Capacity_Per_Month2: string;
    supply_Value_Per_Month2: string;


    modified: Date;
    created: Date;
    createdBy: string;
    modifiedBy: string;
*/
}
